import _app from '../../../server';

import React from 'react';
import PropTypes from 'prop-types';

import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import defPic from 'assets/img/icons/default_pic.jpg';

const moment = require('moment');

const ReportTable = ({ sm, md, rowsData, getRowsData, dispatch, onRowDoubleClicked, token }) => {
    const { pagination, data } = rowsData;
    const { currentPage, itemPerPage } = pagination
    const { byid, list } = data

    let tableData = [];
    let indexEnd = currentPage * itemPerPage;
    let indexStart = indexEnd - itemPerPage
    if (indexEnd > list.length) {
        indexEnd = list.length
    }

    let itemsList = list.slice(indexStart, indexEnd)
    let isItemNull = itemsList.find((e) => {
        return (e === -1)
    })
    if (!isItemNull) {
        let bil = indexStart + 1;
        itemsList.forEach((id) => {
            let collection = byid[id];
            const { reporter, target, ...report } = collection;
            const { patrollers } = reporter;
            let item = {
                link: []
            }

            let names = patrollers.map(p => {
                return (
                    <p key={p.name} className='table-text-cont' >
                        {p.name}
                    </p >
                )
            });

            for (let i = 0; i < patrollers.length; i++) {
                let img_link = defPic;
                if (patrollers[i].container !== null && patrollers[i].filename !== null) {
                    img_link = `${_app.api}Storages/${patrollers[i].container}/download/${patrollers[i].filename}?access_token=${token}`;
                } else if (patrollers[i].link !== null) {
                    img_link = patrollers[i].link;
                }
                item['link'] = [...item['link'], img_link];
            }

            item["report_id"] = `${id}`
            item["target_id"] = report.targetId
            if (!collection.isRead) {
                item["bil"] = <b>{bil++}</b>
                item["sender"] = <b><div>{names}</div></b>
                item["subject"] = <b>{report.issue}</b>
                item["target"] = <b>{target.name}</b>
                item["timestamp"] = <b>{moment(collection.createdAt).format("YYYY/MM/DD hh:mm:ss A")}</b>
            }
            else {
                item["bil"] = `${bil++}.`
                item["sender"] = <div>{names}</div>
                item["subject"] = report.issue
                item["target"] = target.name
                item["timestamp"] = moment(collection.createdAt).format("YYYY/MM/DD hh:mm:ss A")
            }
            tableData.push(item)
        })
    }
    else {
        dispatch(getRowsData(indexStart, itemPerPage))
    }

    let imgFormatter = (links, row) => {
        let avatars = links.map(link => {
            return (
                <div className='table-img-cont' key={Math.random() + row.report_id} style={{ padding: "5px" }}>
                    <img
                        src={link}
                        height='100%'
                        alt=''
                    />
                </div>
            )
        })
        return (
            <div>
                {avatars}
            </div>
        );
    };

    let columns = [
        {
            dataField: 'report_id',
            text: '#',
            headerClasses: "table-col-head",
            hidden: true
        }, {
            dataField: 'target_id',
            text: '#',
            headerClasses: "table-col-head",
            hidden: true
        }, {
            dataField: 'bil',
            text: '#',
            headerClasses: "table-col-head",
            headerStyle: { 'whiteSpace': 'nowrap', "width": "30px" },
            sort: true,
        }, {
            dataField: 'link',
            text: ' ',
            headerClasses: 'table-col-head',
            headerStyle: { width: '90px' },
            formatter: imgFormatter,
            sort: false
        }, {
            dataField: 'sender',
            text: 'From',
            headerClasses: "table-col-head",
            sort: true
        }, {
            dataField: 'subject',
            text: 'Subject',
            headerClasses: "table-col-head",
            sort: true,
            hidden: sm
        }, {
            dataField: 'target',
            text: 'To',
            hidden: md,
            headerClasses: "table-col-head",
            sort: true
        }, {
            dataField: 'timestamp',
            text: 'Date/Time',
            headerClasses: "table-col-head",
            sort: true,
            headerStyle: { "width": "25%" }
        }
    ];

    const rowEvents = {
        onDoubleClick: (e, row) => {
            onRowDoubleClicked(row)
        }
    };

    return (
        <BootstrapTable
            bootstrap4
            classes="table-md table-responsive-sm text-center align-middle"
            keyField='report_id'
            data={tableData}
            columns={columns}
            striped
            condensed
            hover
            bordered={false}
            noDataIndication="Record not found"
            rowEvents={rowEvents}
        />
    )
};

ReportTable.propTypes = {
    sm: PropTypes.bool,
    md: PropTypes.bool,
    getRowsData: PropTypes.func,
    rowsData: PropTypes.object,
    dispatch: PropTypes.func,
    onRowDoubleClicked: PropTypes.func,
    token: PropTypes.string
};

export default ReportTable;



// WEBPACK FOOTER //
// ./src/components/blocks/ReportTable/ReportTable.js